<template>
    <teleport to="#modal">
        <Loading
            :visible="Lista.loading"
        >
        </Loading>
        <Modal v-model:visible="show_detail" backdrop>
            <template v-slot:header>
                <h2 class="text-2xl font-bold">Dettaglio</h2>
            </template>
            <template v-slot:main>
                <table>
                    <tr v-for="(v,k) in detail" :key="k">
                        <td class="w-1/2 font-bold border border-next-dark-gray">{{ k }}:</td>
                        <td class="w-1/2 border border-next-dark-gray">{{ v }}</td>
                    </tr>
                </table>
            </template>
            <template v-slot:footer>
                <div class="flex justify-between pt-3">
                    <NextButton variant="outline-secondary"
                                @click="show_detail =false"
                                class="py-2 px-4 w-full">
                        Chiudi
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 pb-8">
        <div class="m-auto pt-5">
            <div class="flex items-center justify-between">
                <h2 class="text-3xl font-bold mb-4">Costi Carte: {{ Lista.rows[0]?.nodo || '---' }}</h2>
                <NextButton :disabled="loading_download" variant="secondary" class="p-2" @click="export_data">Esporta
                </NextButton>
            </div>
            <div class="flex flex-col col-span-2 mb-2">
                <Field field_name="Cerca" @update:modelValue="Lista.debounceSearch"
                       v-model="Lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <Switcher v-model="carte_tab"
                      :options="tabs"
                      class="grow whitespace-nowrap mr-3"></Switcher>

                <div class="flex justify-end">
                    <Paginator class="" :pagination="Lista.paginate"></Paginator>
                </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 border-separate border-spacing-3 py-4 table-fixed"
                               v-model:cols="cols"
                               :rows="Lista.rows" @order-update="Lista.updateCols">

                        <template v-for="(c, j) in Lista.rows" :key="j" v-slot:[`td_${j}_2`]="context">
                            {{ c.Fornitore }}
                        </template>

                        <template v-for="(c, j) in Lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ $filters.toDate(c.Data_Acquisto) }}
                        </template>

                        <template v-for="(c, j) in Lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toCurrency(c.Importo_valuta) }}
                        </template>

                        <template v-for="(c, j) in Lista.rows" :key="j" v-slot:[`td_${j}_8`]="context">
                            {{ $filters.toEuroCurrency(c.Importo_Euro) }}
                        </template>
                        <template v-for="(c, j) in Lista.rows" :key="j" v-slot:[`td_${j}_13`]="context">
                        <span @click="showData(c)"
                              class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></span>

                        </template>
                    </NextTable>
                </div>

                <InfiniteLoading @infinite="Lista.fetchNextPage"
                                 :identifier="Lista.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altre righe.</div>
                    </template>
                </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import sottoProgettiManager from "@/api/SottoProgetti";
import NextButton from "@/components/NextButton.vue";
import InfiniteLoading from "v3-infinite-loading";
import Field from "@/components/Field.vue";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import Lista from "@/setup/ListaCerca";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";
import Switcher from "@/components/Switcher.vue";

@Options({
    name: 'CostiRicaviCarteSottoProgetto',
    components: {Switcher, Loading, Modal, NextTable, Paginator, InfiniteLoading, Field, NextButton},
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class CostiRicaviCarteSottoProgetto extends Vue {
    lista_treno: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiCarte));
    lista_aereo: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiCarte));
    lista_varie: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiCarte));

    id!: string;
    show_detail = false
    detail = null
    tabs = ['Costi Aereo', 'Costi Treni', 'Costi Varie']
    carte_tab = 0
    loading_download = false

    get Lista(){
        return this.carte_tab === 0 ? this.lista_aereo : this.carte_tab === 1 ? this.lista_treno : this.lista_varie
    }

    created() {
        this.lista_treno.callBinds = [this.id]
        this.lista_treno.apiParams = {'tipo_spesa': 'Treno'}
        this.lista_treno.fetchData()

        this.lista_aereo.callBinds = [this.id]
        this.lista_aereo.apiParams = {'tipo_spesa': 'Aereo'}
        this.lista_aereo.fetchData()

        this.lista_varie.callBinds = [this.id]
        this.lista_varie.apiParams = {'tipo_spesa': 'Varie'}
        this.lista_varie.fetchData()

    }

    export_data(){
        this.loading_download = true
        sottoProgettiManager.costiCarte(this.id,{
            responseType: 'blob',params: {export:1}
        }).then((response: any) => {
            let downloadUrl = URL.createObjectURL(response.data);
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `costi_carte_${this.lista_treno.rows[0]?.nodo}.xlsx`;
            document.body.appendChild(a);
            a.click();
        }).finally(() => {
            this.loading_download = false
        })
    }

    showData(data: any) {
        this.detail = data
        this.show_detail = true
    }

    cols = [
        {
            name: 'Id',
            prop: 'Id',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Descrizione',
            prop: 'Descrizione_Acquisto',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Fornitore',
            prop: 'Fornitore',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Naz.',
            prop: 'Nazione_fornitore',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data acquisto',
            prop: 'Data_Acquisto',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Importo valuta',
            prop: 'Importo_valuta',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Valuta',
            prop: 'Tipo_Valuta',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Cambio',
            prop: 'cambio',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Importo euro',
            prop: 'Importo_Euro',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Documento',
            prop: 'Tipo_Doc_CC',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'N° CC',
            prop: 'Num_carta',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Nominativi',
            prop: 'Nominativi',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Tipo spesa',
            prop: 'tipo_spesa_cc_calcolato',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
